import { ContextsService, type PendingApprovalDto } from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/inference-client';

export type PendingApproval = PendingApprovalDto;

/** One answer to one question: the options picked, what was typed, or both. */
export interface QuestionAnswer {
  question: string;
  selected: string[];
  other?: string;
}

/** How a person answered one approval or question, as the message endpoint takes it. */
export interface ToolApprovalDecision {
  approvalId: string;
  approved: boolean;
  reason?: string;
  /** For a question accepted: one answer per question. */
  answers?: { answers: QuestionAnswer[] };
}

export async function getPendingApprovals(contextId: string): Promise<PendingApproval[]> {
  const response = await ContextsService.getPendingApprovals({
    client: inferenceHttp,
    throwOnError: true,
    path: { contextId },
  });
  return response.data.data;
}
